import React from "react";
import { NextPage } from "next";
import { useRouter } from "next/router";
import Head from "next/head";
import { Signup, Layout } from "@components";

const SignupPage: NextPage = () => {
    const router = useRouter();

    return (
        <>
            <Head>
                <title>RoboEpics | ایجاد حساب کاربری</title>
                <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            </Head>
            <Layout>
                <Signup router={router} />
            </Layout>
        </>
    );
};

export default SignupPage;
